"use client";

import { useState } from "react";
import FeatureListItem from "./FeatureListItem";

export default function Features({ description, features }) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="w-full bg-[#c18cb7] text-black dark:bg-white lg:-mt-72">
      <div className="flex flex-col p-6 lg:p-20">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:gap-8">
          {/* Left Column with Headers and Features */}
          <div className="w-full lg:w-1/2">
            {/* Headers */}
            <div className="mb-10 w-full lg:mb-20">
              <h2 className="max-w-full py-3 font-questrial text-3xl font-bold dark:text-black lg:max-w-[100%] lg:text-5xl">
                Rewrite the way you write.
              </h2>
              <h2 className="max-w-full py-3 font-questrial text-3xl font-light dark:text-black lg:max-w-[100%] lg:text-5xl">
                {description}
              </h2>
            </div>

            {/* Features List */}
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <FeatureListItem
                  key={index}
                  icon={feature.icon}
                  text={feature.text}
                  description={feature.description}
                  isActive={activeIndex === index}
                  onClick={() => setActiveIndex(index)}
                  image={feature.image}
                />
              ))}
            </ul>
          </div>

          {/* Right Column with Desktop Image */}
          <div className="hidden w-full md:flex md:w-1/2 md:items-start md:justify-center">
            <img
              src={features[activeIndex].image}
              alt={features[activeIndex].text}
              className={`animate-fadeIn max-h-[70vh] w-auto object-contain ${activeIndex === 0 ? "lg:max-h-[95vh]" : "lg:max-h-[80vh]"}`}
              key={`desktop-${activeIndex}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
